import { render, staticRenderFns } from "./general_searchbox.vue?vue&type=template&id=08a89dd0&scoped=true&"
import script from "./general_searchbox.vue?vue&type=script&lang=js&"
export * from "./general_searchbox.vue?vue&type=script&lang=js&"
import style0 from "./general_searchbox.vue?vue&type=style&index=0&id=08a89dd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a89dd0",
  null
  
)

export default component.exports